import * as React from 'react'
import { LocalDate as LD } from 'js-joda'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'
import { Field, FieldProps, FormikProps } from 'formik'

import { WithDatepicker } from '@espoon-voltti/react-datepicker'

import { LocalDate } from '@espoon-voltti/ts-libs/lib/time'
import { Input, ControlField } from '@espoon-voltti/react-components'

import {
  ErrorMessage,
  fieldState,
  setFieldTouched,
  setFieldValue
} from '../formik-util'
import { InputProps } from './types'

interface DateInputProps {
  form: FormikProps<unknown>
  field: FieldProps['field']
  defaultValue?: LD
}

const FormDateInput: React.FC<DateInputProps> = (p: DateInputProps) => {
  const value = pipe(
    p.field.value,
    O.fromPredicate<LocalDate>((x) => x instanceof LocalDate),
    O.map((x) => x.d),
    O.toNullable
  )

  const handleChange = (value: LD | null) => {
    setFieldValue(p.form, p.field.name)(value ? new LocalDate(value) : null)
  }

  const handleInputBlur = () => {
    setFieldTouched(p.form, p.field.name)()
  }

  return (
    <>
      <WithDatepicker
        value={value}
        onChange={handleChange}
        onBlur={handleInputBlur}
        defaultValue={p.defaultValue}
      >
        {(datePickerfield) => <Input {...datePickerfield} />}
      </WithDatepicker>
    </>
  )
}

export const FormDateField = (p: InputProps) => {
  return (
    <Field name={p.name}>
      {({ field, form }: FieldProps) => (
        <ControlField
          required={p.required}
          dataQa={p.dataQa}
          {...field}
          label={p.label}
          state={fieldState(field.name, form)}
          message={<ErrorMessage name={field.name} />}
          disabled={p.disabled}
        >
          <FormDateInput
            form={form}
            field={field}
            defaultValue={p.defaultDate}
          />
        </ControlField>
      )}
    </Field>
  )
}
